<aside class="fixed w-64 h-screen bg-slate-900 text-slate-300 flex flex-col shadow-2xl">
  <div class="p-6 border-b border-slate-800">
    <h1 class="text-white font-normal text-xl tracking-tight">Admin Dashboard</h1>
  </div>

  <nav class="flex-1 overflow-y-auto custom-scrollbar py-4 px-3 space-y-1">

    <div class="group flex flex-col mb-1">
      <button (click)="selectItem('Article')"
        class="flex w-full items-center justify-between px-4 py-3 rounded-xl transition-all hover:bg-indigo-600 hover:text-white"
        [class.bg-indigo-600]="selectedItem === 'Article'" [class.text-white]="selectedItem === 'Article'">

        <div class="flex items-center">
          <svg class="w-5 h-5 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z">
            </path>
          </svg>
          <span class="font-medium">Article</span>
        </div>

        <svg class="w-4 h-4 transition-transform duration-300" [class.rotate-180]="selectedItem === 'Article'"
          fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
        </svg>
      </button>

      <ul *ngIf="selectedItem === 'Article'" class="mt-2 ml-6 space-y-1 border-l-2 border-slate-700 pl-3">
        <li>
          <a routerLink="admin/article/0/1"
            class="flex items-center px-3 py-2 rounded-lg transition-all text-slate-400 hover:bg-indigo-500/20 hover:text-white">
            <svg class="w-4 h-4 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path>
            </svg>
            <span class="text-sm font-medium">Ajouter</span>
          </a>
        </li>
        <li>
          <a routerLink="admin/liste/article"
            class="flex items-center px-3 py-2 rounded-lg transition-all text-slate-400 hover:bg-indigo-500/20 hover:text-white">
            <svg class="w-4 h-4 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 10h16M4 14h16M4 18h16">
              </path>
            </svg>
            <span class="text-sm font-medium">Liste</span>
          </a>
        </li>
      </ul>
    </div>

    <a (click)="selectItem('Catégorie')" routerLink="admin/categorie"
      class="flex items-center px-4 py-3 rounded-xl transition-all hover:bg-indigo-600 hover:text-white">
      <mat-icon class="!w-5 !h-5 !text-lg mr-3 mb-2">device_hub</mat-icon>
      <span class="font-medium">Catégorie</span>
    </a>

    <a (click)="selectItem('Gestion des clients')" routerLink="admin/gestion-clients"
      class="flex items-center px-4 py-3 rounded-xl transition-all hover:bg-indigo-600 hover:text-white">
      <mat-icon class="!w-5 !h-5 !text-lg mr-3 mb-2">person</mat-icon>
      <span class="font-medium">Gestion des clients</span>
    </a>

    <a (click)="selectItem('Caractéristiques')" routerLink="admin/caracteristique"
      class="flex items-center px-4 py-3 rounded-xl transition-all hover:bg-indigo-600 hover:text-white">
      <mat-icon class="!w-5 !h-5 !text-lg mr-3 mb-2">playlist_add</mat-icon>
      <span class="font-medium">Caractéristiques</span>
    </a>

    <a (click)="selectItem('Modèle caractéristiques')" routerLink="admin/modelcaracteristique"
      class="flex items-center px-4 py-3 rounded-xl transition-all hover:bg-indigo-600 hover:text-white">
      <mat-icon class="!w-5 !h-5 !text-lg mr-3 mb-2">bookmark</mat-icon>
      <span class="font-medium">Modèle caractéristiques</span>
    </a>

    <a (click)="selectItem('Groupe catégories')" routerLink="admin/groupe/categorie"
      class="flex items-center px-4 py-3 rounded-xl transition-all hover:bg-indigo-600 hover:text-white">
      <mat-icon class="!w-5 !h-5 !text-lg mr-3 mb-2">device_hub</mat-icon>
      <span class="font-medium">Groupe catégories</span>
    </a>

    <a (click)="selectItem('Image et vidéo')" routerLink="link"
      class="flex items-center px-4 py-3 rounded-xl transition-all hover:bg-indigo-600 hover:text-white">
      <mat-icon class="!w-5 !h-5 !text-lg mr-3 mb-2">screen_share</mat-icon>
      <span class="font-medium">Image et vidéo</span>
    </a>

    <a (click)="selectItem('Selection Spéciaux')" routerLink="admin/custom-selection"
      class="flex items-center px-4 py-3 rounded-xl transition-all hover:bg-indigo-600 hover:text-white">
      <mat-icon class="!w-5 !h-5 !text-lg mr-3 mb-2">app_registration</mat-icon>
      <span class="font-medium">Selection Spéciaux</span>
    </a>

    <a (click)="selectItem('Bannière')" routerLink="admin/banniere"
      class="flex items-center px-4 py-3 rounded-xl transition-all hover:bg-indigo-600 hover:text-white">
      <mat-icon class="!w-5 !h-5 !text-lg mr-3 mb-2">panorama</mat-icon>
      <span class="font-medium">Bannière</span>
    </a>

    <a (click)="selectItem('Marque')" routerLink="admin/marque"
      class="flex items-center px-4 py-3 rounded-xl transition-all hover:bg-indigo-600 hover:text-white">
      <mat-icon class="!w-5 !h-5 !text-lg mr-3 mb-2">copyright</mat-icon>
      <span class="font-medium">Marque</span>
    </a>

    <a (click)="selectItem('Gestionnaire de contenu')" routerLink="content/manager"
      class="flex items-center px-4 py-3 rounded-xl transition-all hover:bg-indigo-600 hover:text-white">
      <mat-icon class="!w-5 !h-5 !text-lg mr-3 mb-2">filter</mat-icon>
      <span class="font-medium">Gestionnaire de contenu</span>
    </a>

    <a (click)="selectItem('Blogues')" routerLink="blogues"
      class="flex items-center px-4 py-3 rounded-xl transition-all hover:bg-indigo-600 hover:text-white">
      <mat-icon class="!w-5 !h-5 !text-lg mr-3 mb-2">comment</mat-icon>
      <span class="font-medium">Blogues</span>
    </a>

    <a (click)="selectItem('Équipe de travail')" routerLink="equipe/travail"
      class="flex items-center px-4 py-3 rounded-xl transition-all hover:bg-indigo-600 hover:text-white">
      <mat-icon class="!w-5 !h-5 !text-lg mr-3 mb-2">group</mat-icon>
      <span class="font-medium">Équipe de travail</span>
    </a>

    <a (click)="selectItem('Commandes')" routerLink="commandes"
      class="flex items-center px-4 py-3 rounded-xl transition-all hover:bg-indigo-600 hover:text-white">
      <mat-icon class="!w-5 !h-5 !text-lg mr-3 mb-2">list</mat-icon>
      <span class="font-medium">Commandes</span>
    </a>

    <a (click)="selectItem('Instagram')" routerLink="instagram"
      class="flex items-center px-4 py-3 rounded-xl transition-all hover:bg-indigo-600 hover:text-white">
      <mat-icon class="!w-5 !h-5 !text-lg mr-3 mb-2">camera_alt</mat-icon>
      <span class="font-medium">Instagram</span>
    </a>

    <a (click)="selectItem('Référencement')" routerLink="admin/referencement"
      class="flex items-center px-4 py-3 rounded-xl transition-all hover:bg-indigo-600 hover:text-white">
      <mat-icon class="!w-5 !h-5 !text-lg mr-3 mb-2">scale</mat-icon>
      <span class="font-medium">Référencement</span>
    </a>

    <a (click)="selectItem('Paramètres')" routerLink="admin/settings"
      class="flex items-center px-4 py-3 rounded-xl transition-all hover:bg-indigo-600 hover:text-white">
      <mat-icon class="!w-5 !h-5 !text-lg mr-3 mb-2">settings</mat-icon>
      <span class="font-medium">Paramètres</span>
    </a>
  </nav>

  <div class="p-4 border-t border-slate-800">
    <button (click)="logout()"
      class="flex w-full items-center px-4 py-3 text-red-400 hover:bg-red-500/10 hover:text-red-300 rounded-xl transition-all">
      <mat-icon class="!w-5 !h-5 !text-lg mr-3 mb-2">logout</mat-icon>
      <span class="font-medium">Déconnexion</span>
    </button>
  </div>
</aside>